import React, { useState, useEffect } from 'react'
import { ToastBottomEnd } from '../../components/Toast';
import { toastSuccessCLipboardCopySuccessMessageConfig } from '../../../config/toastConfig';
import moment from 'moment';
import axios from 'axios';
import appConfig from '../../../config/appConfig';
import { AUTH_TOKEN } from '../../../constants/token';
import { verifyTokenExpire } from '../../../middleware/verifyToken';
import { useTranslation } from 'react-i18next';

const ListDiscussionBlock = ({numero, sender, lastMessage, date, activeChat, id, changeChat, isread, channel, responsable, responsableId, responsableIdentite, currentUserId, onReloadDiscussions}) => {
    const { t } = useTranslation();
    const [isSupportLoading, setIsSupportLoading] = useState(false);
    const [showResponsableTooltip, setShowResponsableTooltip] = useState(false);
    const [showActionsMenu, setShowActionsMenu] = useState(false);
    
    // Vérifier si la discussion est prise en charge (si responsable_identite ou un id de responsable existe)
    const isSupported = (responsableIdentite != null && responsableIdentite !== '') || !!responsableId || !!responsable;
    
    // Vérifier si l'utilisateur actuel est le responsable
    const resolvedResponsableId = responsable
        ? (typeof responsable === 'object' ? responsable.id : responsable)
        : responsableId;
    const isCurrentUserResponsible = resolvedResponsableId && currentUserId && resolvedResponsableId === currentUserId;
    
    const loadSociaIcon = () => {
        switch (channel) {
            case 'facebook':
                return "fa-facebook"
                break;
            case 'whatsapp':
                return "fa-whatsapp"
                break;
            case 'linkedin':
                return "fa-linkedin"
                break;
            default:
                break;
        }
    }

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            ToastBottomEnd.fire(toastSuccessCLipboardCopySuccessMessageConfig())
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }

        const handleSupportToggle = async (e, action) => {
        e.stopPropagation(); // Empêcher le clic de déclencher changeChat
        const newStatus = action === 'prendre' ? 1 : 0;
        setIsSupportLoading(true);
        
        axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
        if(verifyTokenExpire()) {
            try {
                await axios.put(
                    appConfig.apiDomaine + `/social-network/discussions/${id}/support/${newStatus}`
                );
                // Recharger les discussions pour avoir les données à jour depuis l'API
                if(onReloadDiscussions) {
                    onReloadDiscussions();
                }
            } catch (error) {
                console.error('Erreur lors du changement de statut de prise en charge:', error);
            } finally {
                setIsSupportLoading(false);
            }
        }
    }

    // Fermer le menu 3 points lorsqu'on clique ailleurs dans la page
    useEffect(() => {
        if (!showActionsMenu) return;

        const handleWindowClick = () => {
            setShowActionsMenu(false);
        };

        window.addEventListener('click', handleWindowClick);
        return () => {
            window.removeEventListener('click', handleWindowClick);
        };
    }, [showActionsMenu]);
    
    return (
        <li onClick={()=>changeChat(id)}>
            {/*LISTE DISCUSSION GAUCHE*/}
            <div className="kt-widget__items">
                {/* 
                    On met en évidence les discussions non lues :
                    - fond légèrement coloré
                    - texte du nom en gras
                */}
                <div 
                    className="kt-widget__item border p-3 rounded-lg"
                    style={{
                        backgroundColor: !isread ? '#FFF4DE' : '#FFFFFF', // non lu : jaune pâle
                        cursor: 'pointer'
                    }}
                >
                    {/*ICONE*/}
                    <i className={`fab ${loadSociaIcon()} fa-2x text-success`}></i>

                    {/*DISCUSSION*/}
                    <div className="kt-widget__info">
                        {/*NOM + menu actions*/}
                        <div className="kt-widget__section" style={{minWidth: '100%', width: '100%'}}>
                            <div className="d-flex justify-content-between align-items-center" style={{minWidth: '100%', width: '100%'}}>
                                <div>
                                    <a
                                        href={"#messageList"}
                                        activeclassname="kt-menu__item--active"
                                        aria-haspopup="true"
                                        className={`kt-widget__username ${!isread ? 'font-weight-bold' : ''}`}
                                    >
                                        {sender ?? numero}

                                        <span
                                            onClick={(e) => { e.stopPropagation(); copyToClipboard(numero); }}
                                            className="ml-2 text-decoration-none"
                                        >
                                            <i className="fa fa-copy"></i>
                                        </span>
                                    </a>
                                    {
                                        activeChat && activeChat === id ? (
                                            <span className="kt-badge kt-badge--success kt-badge--dot">
                                                {" "}
                                            </span>   
                                        ) : (
                                            !isread ? (
                                                <span className="kt-badge kt-badge--danger kt-badge--dot">
                                                    {" "}
                                                </span>
                                            ) : ""
                                        )
                                    }
                                </div>

                                {/* Menu 3 points pour Prendre en charge / Terminer */}
                                <div
                                    className="position-relative"
                                >
                                    <i
                                        className="fa fa-ellipsis-v"
                                        style={{ cursor: 'pointer', fontSize: '16px' }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowActionsMenu(!showActionsMenu);
                                        }}
                                    ></i>
                                    {showActionsMenu && (
                                        <div
                                            className="position-absolute bg-white border rounded shadow"
                                            style={{
                                                right: 0,
                                                top: '20px',
                                                zIndex: 1000,
                                                minWidth: '170px',
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            {/* Bouton Prendre en charge :
                                                - visible si la discussion n'est pas prise en charge
                                                - ou si elle est prise en charge par quelqu'un (pour la reprendre)
                                            */}
                                            {(!isSupported || (isSupported && !isCurrentUserResponsible)) && (
                                                <button
                                                    type="button"
                                                    className="btn btn-link btn-sm d-block text-left w-100"
                                                    onClick={(e) => {
                                                        setShowActionsMenu(false);
                                                        handleSupportToggle(e, 'prendre');
                                                    }}
                                                    disabled={isSupportLoading}
                                                >
                                                    {isSupportLoading ? (
                                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                    ) : (
                                                        <i className="fa fa-circle mr-2"></i>
                                                    )}
                                                    {t("Prendre en charge")}
                                                </button>
                                            )}

                                            {/* Bouton Terminer :
                                                - visible uniquement si l'utilisateur courant est le responsable
                                            */}
                                            {isSupported && isCurrentUserResponsible && (
                                                <button
                                                    type="button"
                                                    className="btn btn-link btn-sm d-block text-left w-100"
                                                    style={{
                                                        color: '#f1416c',
                                                        transition: 'all 0.2s'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor = '#f1416c';
                                                        e.target.style.color = '#ffffff';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor = 'transparent';
                                                        e.target.style.color = '#f1416c';
                                                    }}
                                                    onClick={(e) => {
                                                        setShowActionsMenu(false);
                                                        handleSupportToggle(e, 'terminer');
                                                    }}
                                                    disabled={isSupportLoading}
                                                >
                                                    {isSupportLoading ? (
                                                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                    ) : (
                                                        <i className="fa fa-times-circle mr-2"></i>
                                                    )}
                                                    {t("Terminer")}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <span className="kt-widget__desc">
                            {lastMessage}
                        </span>
                        
                        <div className="kt-widget__action d-flex justify-content-between align-items-center">
                            <span className="kt-widget__date">
                                {moment(date).format("ll HH:mm")}
                            </span>
                            <div className="d-flex align-items-center gap-2">
                                {/* Indicateur responsable - toujours visible si un responsable existe */}
                                {(responsable || responsableId) && (
                                    <div 
                                        className="position-relative"
                                        onMouseEnter={() => setShowResponsableTooltip(true)}
                                        onMouseLeave={() => setShowResponsableTooltip(false)}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowResponsableTooltip(!showResponsableTooltip);
                                        }}
                                    >
                                        {!isCurrentUserResponsible ?
                                            <i 
                                                className="fa fa-user-circle text-primary" 
                                                style={{ cursor: 'pointer', fontSize: '18px' }}
                                                title={responsableIdentite || 'Responsable'}
                                            ></i>
                                        :
                                            <i 
                                                className="fa fa-check-circle text-success" 
                                                style={{ cursor: 'pointer', fontSize: '18px' }}
                                            ></i>
                                        }
                                        {showResponsableTooltip && (
                                            <div 
                                                className="position-absolute bg-dark text-white p-2 rounded shadow"
                                                style={{
                                                    bottom: '100%',
                                                    left: '-100%',
                                                    transform: 'translateX(-50%)',
                                                    marginBottom: '5px',
                                                    whiteSpace: 'nowrap',
                                                    zIndex: 1000,
                                                    fontSize: '12px'
                                                }}
                                            >
                                                {responsableIdentite || 'Responsable'}
                                                <div 
                                                    className="position-absolute"
                                                    style={{
                                                        bottom: '-5px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        width: 0,
                                                        height: 0,
                                                        borderLeft: '5px solid transparent',
                                                        borderRight: '5px solid transparent',
                                                        borderTop: '5px solid #000'
                                                    }}
                                                ></div>
                                            </div>
                                        )}
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}

export default ListDiscussionBlock